import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'
import Components from '@/config/components'
import CustomLoading from '@/components/loading.vue'
import sysConstConfig from '@/config/base'

Vue.use(Components)
Vue.component('custom-loading', CustomLoading)

Vue.mixin({
  data () {
    return {
      sysConstConfig
    }
  }
})

new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})